export default "__VITE_ASSET__Do9vV7pL__"